import { useMemo } from "react";
import { useClientQuery } from "web_myplann/Api/Client/useClientQuery";
import { usePaperworkDocuments } from "web_myplann/Profile/Hooks/usePaperworkDocuments";

export const usePaperworkDocument = (id?: string) => {
	const {
		documents,
		isLoading,
		isPending,
		isError,
		isSuccess,
		isRefetching,
		refetch,
	} = usePaperworkDocuments();
	// issuer is a non-essential enrichment (see below) — its own query error
	// must not escalate into the document list's error/loading state.
	const { data: client } = useClientQuery();

	const document = useMemo(
		() => documents.find((doc) => String(doc.id) === id),
		[documents, id],
	);

	// The list DTO carries no issuer; until the detail endpoint exists it comes
	// from the already-cached /v2/client identification documents.
	const issuer = useMemo(
		() =>
			client?.identificationDocuments?.find((doc) => String(doc.id) === id)
				?.issuer,
		[client, id],
	);

	return {
		document,
		issuer,
		isLoading,
		isPending,
		isError,
		isSuccess,
		isRefetching,
		refetch,
	};
};
